<template>
  <div id="invalid-username-page">
    <the-header></the-header>
    <ForgotUserNameBG />

    <!-- Form Content-->
    <div class="form-container smaller-header" id="main">
      <div class="noti-container">
        <div class="overlay-info">
          <div class="headImgContainer">
            <img
              srcset="@/assets/images/sadface.png 1x, @/assets/images/sadface-2x.png 2x"
              src="@/assets/images/sadface-2x.png"
              alt="browser with sad face illustration"
            />
          </div>
          <div class="bg-text1">
            <h3 class="bg-text-line">We are unable to retrieve your username at this time</h3>
            <p class="bg-text-line1">
              Your one time link may have expired. Please try again, or contact customer service for
              further assistance.
            </p>
            <div class="bg-text-line2">
              <p>
                Need help? Contact Customer Service
                <br />
                Daily 7am–7pm HST
                <br />
                (808) 643-4343 (Oahu)
                <br />
                (888) 643-4343 (Toll Free)
              </p>
            </div>
          </div>

          <!-- Links -->
          <div class="bottomLinksContainer">
            <a
              href=""
              @click="goToForgotUsername"
              id="invalid-username-to-forgot"
              data-test="invalid-un-forgot-link"
              >Return to forgot username form</a
            >
            <a :href="fhbOnline" id="invalid-username-to-login" data-test="invalid-un-login-link"
              >Go to login</a
            >
          </div>
        </div>
      </div>
    </div>
    <the-footer />
  </div>
</template>

<script>
import jQuery from "jquery"
import TheHeader from "@/components/header"
import TheFooter from "@/components/footer"
import ForgotUserNameBG from "@/components/forgotusernamebg"

export default {
  name: "invalidUsername",
  components: { TheHeader, TheFooter, ForgotUserNameBG },
  data() {
    return {
      fhbOnline: process.env.VUE_APP_FHB_ONLINE_URL,
    }
  },
  mounted() {
    jQuery("html, body").animate({ scrollTop: 0 })
  },
  methods: {
    goToForgotUsername() {
      this.$router.push({ name: "forgot-username" })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/scss/_variables.scss";
@import "./src/scss/_mixins.scss";

.headImgContainer {
  position: relative;
  height: auto;
  text-align: center;
}

.noti-spacing.noti-container {
  padding-top: 40px;
}
img {
  padding-top: 30px;
  padding-bottom: 15px;
  height: auto;
  width: 93.5px;
}

.bg-text-line {
  font-weight: 500;
  font-size: 26px;
  margin-bottom: 10px;
  text-align: center;
}

.bg-text1 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bg-text-line1 {
  margin: 0 0 0 0;
  font-weight: 450;
  font-size: 15.5px;
  text-align: center;
}

.bg-text-line2 {
  margin: 0 0 0 0;
  font-weight: 450;
  font-size: 15.5px;
  text-align: center;
}

button {
  height: 55px;
  width: 277px;
  position: relative;
  background-color: #fec443;
  border: 1px solid white;
  color: #444444;
  cursor: pointer;
  letter-spacing: 0.029em;
  border-radius: 30px;
  margin-top: 40px;
  display: inline-block;
  font-family: "CircularXX TT";
  font-weight: 700;
  line-height: 24px;
  align-items: center;
  text-align: center;
  font-feature-settings: "cpsp" on;
}

/* a:hover,
  a:active, */
button:hover,
button:active {
  background-color: #fed67b;
  border-color: white;
}

.submitBtn {
  position: relative;
  text-align: center;
  padding-bottom: 50px;
}

a:hover,
a:active {
  color: $redDark;
}

.bottomLinksContainer {
  display: grid;
  padding-top: 10px;
  justify-content: center;
  text-align: center;
  row-gap: 15px;
}
</style>
